// Shared hover/click hit rule for ships and air/truck markers (pure, node --test).
export const SHIP_RADIUS_PX = 20;
export const MODE_RADIUS_PX = 17;
export const MODE_SELECTED_RADIUS_PX = 23;

/**
 * Nearest centre inside its OWN radius wins; an exact tie goes to the ship.
 * ships: [{ x, y, ... }] visual arrow centres; modes: [{ x, y, selected?, ... }] marker centres.
 * Returns { kind: 'ship' | 'mode', cand } or null.
 */
export function pickMapHit(cursor, ships = [], modes = []) {
  let best = null;
  const consider = (kind, cand, radius) => {
    const d = Math.hypot(cand.x - cursor.x, cand.y - cursor.y);
    if (d > radius) return;
    // Ships are considered first, so a later mode candidate must be strictly nearer.
    if (!best || d < best.d) best = { kind, cand, d };
  };
  ships.forEach((c) => consider('ship', c, SHIP_RADIUS_PX));
  modes.forEach((c) => consider('mode', c, c.selected ? MODE_SELECTED_RADIUS_PX : MODE_RADIUS_PX));
  return best ? { kind: best.kind, cand: best.cand } : null;
}
